import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CasiStoryStatus, CasiStoryType, IProjectFromWeb } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiUserStoryStatusService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<CasiStoryStatus[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/userstorystatus`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => CasiStoryStatus.create(x)).sort((a, b) => {
          if (a.user_story_status_description.toLowerCase() < b.user_story_status_description.toLowerCase())
            return -1;
          if (a.user_story_status_description.toLowerCase() > b.user_story_status_description.toLowerCase())
            return 1;
          return 0;
        })),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserStoryStatusService extends CasiUserStoryStatusService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('userstorystatus', 'get')
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`userstorystatus/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('userstorystatus', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`userstorystatus/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`userstorystatus/${id}`, 'destroy');
  }
}
